"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
}); // import { inRange } from '../validation';

exports.calculateCenterToCenterPositions = function (val, idx, spacings) {
  var diff = spacings[idx] && spacings[idx].current - val; // const inCrease = diff < 0 ? false : true;

  var newSpacings = [];
  spacings.map(function (space, index) {
    if (index === idx) {
      space.current = val;
    } else {
      var value = space.current + diff;

      if (value >= space.min && value <= space.max) {
        space.current = value;
      }
    }

    newSpacings.push(space);
  });
  return newSpacings;
};

exports.calculationUtils = {
  calculateCenterToCenterPositions: exports.calculateCenterToCenterPositions
};